import React, { useState, useEffect, useRef } from "react";

import { useDispatch, useSelector, shallowEqual } from "react-redux";
import ImageChecker from "../../Generic/ImageChecker";

import {
  Table,
  Tooltip,
  Tag,
  Form,
  Input,
  Button,
  Space,
  Modal,
  Descriptions,
  Statistic,
  Col,
  Popconfirm,
  Collapse,
  Select,
  DatePicker,
  InputNumber,
  TimePicker,
  Checkbox,
  message,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import "./styles.scss";

import moment from "moment";
import {
  getData,
  editItem,
  addItem,
  deleteItem,
} from "../../../Redux/actions/crudActions";
import { errorParser } from "../../../utils/helpers";
import {
  getWastableItems,
  setWastable,
} from "../../../Redux/actions/wastableActions";

import { getProduct } from "../../../Redux/actions/productActions";
import { setProductInventory } from "../../../Redux/actions/inventoryActions";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({ onModalClose }) => {
  const dispatch = useDispatch();
  const { wastableItems } = useSelector(
    (state) => ({
      wastableItems: state.wastable.wastableItems,
    }),
    shallowEqual
  );

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [loading, setLoading] = useState(false);
  const [categorized, setCategorized] = useState([]);
  const [itemcount, setItemcount] = useState([]);
  const [createDate, setCreatedDate] = useState(moment());

  useEffect(() => {}, []);

  useEffect(() => {
    if (isModalVisible) {
      dispatch(getWastableItems());
    }
  }, [isModalVisible]);

  useEffect(() => {
    if (wastableItems) {
      docategorized();
      console.log(wastableItems);
    }
  }, [wastableItems]);

  const docategorized = () => {
    var categories = [];

    wastableItems.map((it) => {
      if (!categories.includes(it.category_name)) {
        categories.push(it.category_name);
      }
    });
    var newcats = [];
    categories.map((ct) => {
      var catprods = [];
      wastableItems.map((it) => {
        if (ct == it.category_name) {
          catprods.push(it);
        }
      });
      var sortedprods = catprods.sort((a, b) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      );
      var newcatp = {
        category: ct,
        products: sortedprods,
      };
      newcats.push(newcatp);
    });

    console.log(newcats);
    setCategorized(newcats);
  };

  const chagnequantity = (prod, count) => {
    var newItemCount = itemcount;
    newItemCount[prod] = count;
    setItemcount(newItemCount);
    console.log(newItemCount);
  };

  const renderTable = (currentgroup) => {
    const columns = [
      {
        title: "Image",

        render: (text, record, index) => {
          return (
            <ImageChecker
              url={`${process.env.REACT_APP_AWS_S3}${record.id}.png`}
              success={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}${record.id}.png`}
                  alt="image"
                  className={"prodimage"}
                />
              }
              fail={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}logo192.png`}
                  alt="image"
                  className={"prodimage"}
                />
              }
            />
          );
        },
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        width: "100rem",
        sorter: {
          compare: (a, b) => a.name - b.name,
        },

        search: "name",
      },
      {
        title: "count",

        render: (text, record, index) => {
          return (
            <div className="vertical-flex">
              <InputNumber
                min={0}
                width={"100%"}
                defaultValue={0}
                step={1}
                onChange={(e) => {
                  chagnequantity(record.id, e);
                }}
              />
              {record.second_unit_rate &&
              record.second_unit &&
              parseFloat(record.second_unit_rate) > 0 ? (
                <span className="flex-end">{record.second_unit} </span>
              ) : (
                <span className="flex-end">{record.unit}</span>
              )}
            </div>
          );
        },
      },
    ];

    return (
      <Collapse defaultActiveKey={["1"]} className={"category_containter"}>
        <Panel header={currentgroup.category} key="1">
          <Table
            columns={columns}
            dataSource={currentgroup.products}
            pagination={false}
            showHeader={false}
          />
        </Panel>
      </Collapse>
    );
  };

  const summarizeWaste = (thisitemcount) => {
    var wasted_items = [];

    Object.entries(thisitemcount).map((item) => {
      var item_id = item[0];
      var item_quantity = item[1];

      if (item_quantity > 0) {
        var current_prod = wastableItems.filter((x) => x.key == item_id);
        if (current_prod[0]) {
          current_prod = current_prod[0];

          var usequantity = item_quantity;
          if (
            current_prod.second_unit_rate &&
            current_prod.second_unit &&
            parseFloat(current_prod.second_unit_rate) > 0
          ) {
            usequantity =
              parseFloat(item_quantity) *
              parseFloat(current_prod.second_unit_rate);
          }

          var recorded_product = {
            ...current_prod,
            quantity: usequantity,
          };

          wasted_items.push(recorded_product);
        }
      }
    });

    if (wasted_items.length > 0) {
      createWaste(wasted_items);
    } else {
      message.warning("input quatity for an item");
    }
  };

  const createWaste = async (wasted_items) => {
    if (!loading) {
      setLoading(true);
      message.info("recording wastes");

      await Promise.all(
        wasted_items.map(async (indx, i) => {
          var product3 = await dispatch(
            setProductInventory(
              indx.id,
              indx.name,
              indx.quantity,
              "subtract",
              "wasted"
            )
          );
          message.info(
            `(${i + 1}/${wasted_items.length})  ${indx.name} updated`
          );
        })
      );

      var newsold = await dispatch(setWastable(wasted_items, createDate));

      setLoading(false);
      closeModal("reset");
    }
  };
  const disabledDate = (current) => {
    // Can not select days before today and today
    return current && current > moment().endOf("day");
  };

  const footer = () => {
    return (
      <div className="addsalesfooter">
        <div>
          <DatePicker
            defaultValue={createDate}
            value={createDate}
            disabledDate={disabledDate}
            onChange={(e) => {
              setCreatedDate(e);
            }}
          />
        </div>
        <div>
          <Popconfirm
            title="Are you sure this list is correct?"
            onConfirm={() => {
              summarizeWaste(itemcount);
            }}
            okText="Yes"
            cancelText="No"
          >
            <Button type="primary" loading={loading}>
              add
            </Button>
          </Popconfirm>
        </div>
      </div>
    );
  };

  const closeModal = (action) => {
    if (!loading) {
      setItemcount([]);

      setIsModalVisible(false);
      onModalClose(action);
    }
  };

  return (
    <>
      <div className={"addeditbutton"}>
        <Button
          type="primary"
          shape="round"
          icon={<PlusOutlined />}
          onClick={() => {
            setIsModalVisible(true);
            setLoading(false);
          }}
        >{`Add Wasted Items`}</Button>
      </div>

      {isModalVisible ? (
        <Modal
          title={`Add Wasted Items`}
          visible={isModalVisible}
          className={"minwidthis32"}
          footer={footer()}
          onCancel={() => {
            closeModal();
          }}
        >
          <div className="wastes-content">
            {categorized.map((cat) => {
              return renderTable(cat);
            })}
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default Index;
